import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=f6d36a72&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6d36a72')) {
      api.createRecord('f6d36a72', component.options)
    } else {
      api.reload('f6d36a72', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=f6d36a72&", function () {
      api.rerender('f6d36a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wvzD47c4x4si/JS/comp/ImageCarousel.vue"
export default component.exports